<template>
    <div>
      <ba-search-card legend="Historiques de vos imports" style="margin-bottom: 20px;">
          <div  v-for="(fic, idx) in array_list" style="margin: 0px 20px 20px 20px;">
			  <div class="tooltip-container">
				   <div class="filter-link">
					<a v-bind:href="handleGetFileExemple(fic[1])">
					  <ab-icon icon="excel"></ab-icon>
					  <div class="txt_logo_excel">
						{{ fic[0] }}.csv
					  </div>
					</a>
				  </div>
			  </div>
          </div>
      </ba-search-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { AbIcon, BaButton, BaCard, BaDropdown, BaInput, BaSearch, BaSearchCard, BaSelect, BaStateLabel, BaTable } from '@ab/basic-components';

import { fr } from 'vuejs-datepicker/dist/locale';

import paginationMixin from '@/components/mixins/pagination.js';
import requestMixin from '@/components/mixins/request.js';
import searchMixin from '@/components/mixins/search.js';
import sortableMixin from '@/components/mixins/sortable.js';
import { generateSearchWatcher } from '@/assets/js/helpers.js';
import MoLoader from '@/components/loader/mo-loader.vue';

import Datepicker from 'vuejs-datepicker';

export default {
  name: 'DocumentList-statistique',
  components: {
    AbIcon,
    BaButton,
    BaCard,
    BaDropdown,
    BaInput,
    BaSearch,
    BaSearchCard,
    BaSelect,
    BaStateLabel,
    BaTable,
    Datepicker,
    MoLoader
  },
  data() {
    return {
      array_list: '',
      fr: fr,
      isDisabled: false,
      computedDisabledDateFrom: false,
      stateFicheArticle:'general',
      userRole: this.$store.getters.getUserRole,
      date_max: '',
      date_min: '',
      filterOnGoing: false,
      infoFilter:null,
      infoGeneral:null,
      loadingGeneral:true
    };
  },
  computed: {
  },
  async mounted() {
      //chargement des statistique general
      this.infoGeneral = {};
      this.loadingGeneral = false;
      this.array_list = await this.$store.dispatch('getHistoUploadCsv', {});
  },
  methods: {
	handleGetFileExemple(x) {
      const baseApi = process.env.VUE_APP_ROOT_API;
	  return `${baseApi}/upload/importcsv/` + encodeURI(x)
	}
  }
};
</script>
<style src="@/assets/styles/datepickers.css"></style>

